import { ListItemButton, ListItemText } from '@mui/material';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { isActivePath } from '../../utils/page';
import { NavIcon } from './NavIcon';

const isPlainClick = (event) =>
	event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey;

export function NavListItem({ path, text, group, isSub = false, status, onNavigate }) {
	const { pathname } = useLocation();

	// A real link, so Ctrl/middle-click opens the page in a new tab; only a plain click closes the mobile drawer.
	const handleClick = (event) => {
		if (isPlainClick(event)) onNavigate?.();
	};

	return (
		<ListItemButton component={Link} to={`/${path}`} onClick={handleClick} selected={isActivePath(path, pathname)}>
			{group ? (
				<ListItemText primary={text} secondary={group} />
			) : !isSub ? (
				<ListItemText primary={text} />
			) : (
				<ListItemText secondary={text} sx={{ ml: 1 }} />
			)}
			<NavIcon status={status} />
		</ListItemButton>
	);
}
NavListItem.propTypes = {
	path: PropTypes.string,
	text: PropTypes.string,
	group: PropTypes.string,
	isSub: PropTypes.bool,
	status: PropTypes.string,
	onNavigate: PropTypes.func,
};
